/**
 * This directive should serve as a way to
 * remove DOM elements if user is not auhtorized
 * to see or interact with them.
 *
 * Example:
 *
 * Current user role: guest
 *
 * <div class="user-only" v-if-authorized="{ roles: ['user'] }">
 * </div>
 *
 *
 *
 * Other examples:
 *
 * Current user role: user
 * Current user permissions: ['can_read', can_create', 'can_update']
 *
 * <div class="user-can_delete-only"
 *   v-if-authorized="{ roles: ['user'], permissions: ['can_delete']}">
 * </div>
 *
 */
export default {
  bind: function (el, bindings, vnode) {
    el.style.opacity = 0.0
    el.style.pointerEvents = 'none'
    compileAuthorize(el, bindings, vnode)
  },

  update: function (el, bindings, vnode) {
    compileAuthorize(el, bindings, vnode)
  },

  componentUpdated: function (el, bindings, vnode) {
    compileAuthorize(el, bindings, vnode)
  },

  unbind: function (el) {
    el.style.display = null
  }
}

function compileAuthorize (el, bindings, vnode) {
  let permissions = bindings.value.acl || null

  // Run authorization
  var store = window.vue.getStore('root')

  if (store == null) {
    el.style.opacity = 1.0
    el.style.pointerEvents = null
  } else {
    vnode.context.$authorize.isAuthorized(store.getters.getSession.role, permissions).then(function () {
      el.style.opacity = 1.0
      el.style.pointerEvents = null
    }).catch(function () {
      el.style.opacity = 0.4
      el.style.pointerEvents = 'none'
    })
  }
}



// WEBPACK FOOTER //
// ./src/_fdp/core/directive/acl/disable-directive.js